module.exports = __webpack_public_path__ + "media/fonts/PoppinsLatin-Regular-4bfe4ad053ed91b76156d51c321ec340.ttf";